import React from "react";
import { FormattedMessage } from "react-intl";

export const ThrottleMessage: React.FC = () => {
  return (
    <>
      <FormattedMessage
        id="message.throttling"
        defaultMessage="Too many requests were done for your useraccount. "
      />
      <FormattedMessage
        id="message.throttling_please_refresh_page"
        defaultMessage="Please refresh the page after 1 minute "
      />
    </>
  );
};
